import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import SqlQuery from './SqlQuery';
import TableConfig from './TableConfig';
import Table from '../../../../../../components/table/Table';
import { PreloaderBox } from '../../../../../../../../common/ui/Common';
import Preloader from '../../../../../../components/preloader/Preloader';

function SessionResultTable({ sessionDataId }) {
  const [ReportParams, setReportParams] = useState();
  const { reportConfig } = useSelector((state) => state);

  useEffect(() => {
    SqlQuery(sessionDataId).then((resp) => {
      const { dataObjects, query } = resp;
      const params = {
        items: dataObjects,
        query,
        TableConfig: TableConfig(),
      };
      setReportParams(params);
    }).catch((err) => {
      console.error('SessionResultTable error:', err);
      setReportParams({ items: [], TableConfig: TableConfig() });
    });
  }, [reportConfig]);

  return (
    ReportParams !== undefined
      ? (
        <PreloaderBox>
          <Table
            keys="id"
            data={ReportParams.items}
            columns={ReportParams.TableConfig.columns}
            disablePagination
          />
        </PreloaderBox>
      )
      : <Preloader isOpen small />
  );
}

export default SessionResultTable;
